import { get,post } from "@/request/http";

// 校内用户登录接口
export const inSchoolLogin = p => post("/login/inSchoolLogin", p);

// 校外用户登录接口
export const outSchoolLogin = p => get("/login/outSchoolLogin", p);

// 从session获取用户信息
export const getSessionRequest = () => get("/login/getSessionRequest");

// 登出接口
export const logout = () => get("/login/logout");
